import { Link } from 'edenred-ui';
import styled, { css } from 'styled-components';
const linkStyles = css<{ isShowUnderline?: boolean }>`
 text-decoration: ${({ isShowUnderline }) =>
   isShowUnderline ? 'underline' : 'none'}
  font-size: ${props => props.theme.sizeSmall};
  color: ${props => props.theme.primaryLinkColor};

  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
  }
`;

export const StyledLink = styled(Link)`
  ${linkStyles}
`;

export const StyledLinkWithHref = styled.a`
  ${linkStyles}
`;
